import Vue from 'vue'
import { polyfill } from 'es6-promise'
polyfill();

import Vuex from 'vuex'
import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import _ from 'lodash'
import qs from 'qs'
import moment from 'moment'
import { get as getValue } from 'lodash'

let baseURL;

Vue.use(Vuex);
Vue.config.productionTip = false;

baseURL = '/api/web/';

axios.defaults.baseURL = baseURL;
const axiosInstance = axios.create();
axiosInstance.defaults.maxRedirects = 10;
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && [301, 302].includes(error.response.status)) {
      const redirectUrl = error.response.headers.location;
      return axiosInstance.get(redirectUrl);
    }
    return Promise.reject(error);
  }
);
Vue.http = Vue.prototype.$http = axiosInstance;

const AUTOCOMPLETE_METHOD_URL = location.origin;
const DEFAULT_LANGUAGE = document.documentElement.getAttribute('lang') || 'de';

const OLD_BOOKING_CONFIRM_URL = '/api/v1/booking/';

// Build marker: lets us confirm in the browser console that the freshly rebuilt
// bundle (with conditional-CSRF support) is the one actually being served.
const BOOKING_CSRF_BUILD = '2026-06-14 booking-csrf';
console.log('[booking-csrf] store loaded — X-CSRFToken support active (build %s)', BOOKING_CSRF_BUILD);

// Read Django's CSRF cookie. Present only for same-site (sanasearch.ch) visitors;
// absent inside cross-origin coach iframes, where the backend skips CSRF anyway.
function getCsrfToken() {
    const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}

// Build axios config for booking POSTs: send X-CSRFToken when the cookie exists.
function bookingPostConfig() {
    const token = getCsrfToken();
    if (token) {
        console.log('[booking-csrf] csrftoken cookie found → sending X-CSRFToken header');
    } else {
        console.log('[booking-csrf] no csrftoken cookie (iframe / cross-origin) → request sent without CSRF header');
    }
    return { baseURL: '', headers: token ? { 'X-CSRFToken': token } : {} };
}

// SS-1294: helpers for AJAX pagination + hover prefetch. Both the real load
// and the silent prefetch must build identical /coach/ params from the SAME
// filter state, so a prefetched page reflects the user's current
// filters/sorting (never a stale set). The cache key is derived from the
// same params, so any filter change produces a different key and the old
// entries are ignored (and wiped in SET_FILTER / SET_PER_PAGE).

// Max pages kept in the hover-prefetch cache within one filter set. Filter /
// per-page / sort changes wipe the whole cache (SET_FILTER / SET_PER_PAGE),
// so this only bounds growth from many hovers on the same result set.
const PREFETCH_CACHE_MAX_PAGES = 8;

function _paginatedPageParams(filter, page, isInsurancePage) {
    return {
        page,
        ...filter,
        location_name: undefined,
        is_zsr_number_required: isInsurancePage ? true : undefined,
    };
}

function _paginatedPageKey(filter, page, isInsurancePage) {
    return JSON.stringify(_paginatedPageParams(filter, page, isInsurancePage));
}

// SS-1328: a hover prefetch is logged by the backend as a page load that was
// not shown (`prefetch`); showing it later is confirmed via /coach/page_viewed/.
function _prefetchPageParams(filter, page, isInsurancePage) {
    return {
        ..._paginatedPageParams(filter, page, isInsurancePage),
        prefetch: 1,
    };
}

function confirmPageViewed(state, page) {
    const searchQueryId = state.search.searchQueryId;
    if (!searchQueryId || isLandingSsrBotPreview(state)) return;
    Vue.http.get('/coach/page_viewed/', {
        params: {search_query_id: searchQueryId, page},
    }).catch(function () {});
}

// Markers depend on the filter only, not on the list page.
let _mapMarkersRequestSeq = 0;
function _mapMarkersKey(filter, isInsurancePage) {
    const params = _paginatedPageParams(filter, 1, isInsurancePage);
    delete params.page;
    delete params.per_page;
    return JSON.stringify(params);
}

let BOOKING_API;
if (process.env.NODE_ENV === 'production') {
    BOOKING_API = 'https://admin.sanasearch.ch/api';
} else if (process.env.NODE_ENV === 'test') {
    BOOKING_API = 'https://staging-admin.sanasearch.ch/api';
} else {
    BOOKING_API = 'http://localhost:3000/api';
}

const NEW_BOOKING_API = BOOKING_API + '/v2';

const CF = window.cf || {};

CF.page = CF.page || 'search';
CF.model = CF.model || '';
CF.title = CF.title || '';
CF.title = CF.title.trim();
CF.method = CF.model === 'methoden' ? CF.title : '';
CF.symptom = CF.model === 'symptome' ? CF.title : '';
CF.locationName = CF.locationName || '';
CF.lat = CF.lat || null;
CF.lng = CF.lng || null;
CF.keywordsTitle = CF.keywordsTitle || '';
CF.keywordsList = CF.keywordsList || [];
CF.therapistTitle = CF.therapistTitle;
CF.genders = CF.genders || [];
CF.insurances = CF.insurances || [];
CF.insuranceStates = CF.insuranceStates || [];
CF.targetGroups = CF.targetGroups || [];
CF.languages = CF.languages || [];
CF.distances = CF.distances || [];
CF.sortingTypes = CF.sortingTypes || [];
CF.showScarcityLabel = CF.showScarcityLabel || null;
CF.useLandingPagePagination = CF.useLandingPagePagination || false;
CF.useSearchPagePagination = CF.useSearchPagePagination || false;
CF.enablePremiumPlacementSticker = CF.enablePremiumPlacementSticker || false;

// ?act_as_bot=1 keeps Django SSR list (no /coach/ hydrate). ?act_as_bot=0 clears.
// Persists in sessionStorage so you can drop the query after the first load.
function resolveSsrBotPreview() {
    try {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return false;
        }
        var params = new URLSearchParams(window.location.search || '');
        if (params.has('act_as_bot')) {
            var raw = params.get('act_as_bot');
            if (raw === '0' || raw === 'false' || raw === '') {
                window.sessionStorage.removeItem('ssr_bot_preview');
            } else {
                window.sessionStorage.setItem('ssr_bot_preview', '1');
            }
        }
        var on = window.sessionStorage.getItem('ssr_bot_preview') === '1';
        window.cf = window.cf || {};
        window.cf.ssrBotPreview = on;
        return on;
    } catch (e) {
        return false;
    }
}

CF.ssrBotPreview = resolveSsrBotPreview();

function isLandingSsrBotPreview(state) {
    var cf = state && state.search && state.search.CF;
    return !!(cf && cf.page === 'landingpage' && cf.ssrBotPreview);
}

function fetchCoachList(state, httpOptions) {
    if (isLandingSsrBotPreview(state)) {
        return null;
    }
    return Vue.http.get('/coach/', httpOptions);
}

function fetchCoachListUrl(state, url) {
    if (isLandingSsrBotPreview(state)) {
        return null;
    }
    return Vue.http.get(url);
}

function resolveSearchUsePagination(cf) {
    if (!cf) {
        return false;
    }
    cf.useLandingPagePagination = !!cf.useLandingPagePagination;
    cf.useSearchPagePagination = !!cf.useSearchPagePagination;
    cf.usePagination = cf.page === 'landingpage'
        ? cf.useLandingPagePagination
        : cf.useSearchPagePagination;
    return cf.usePagination;
}

resolveSearchUsePagination(CF);
CF.showAutocompleteSectionTitles = CF.showAutocompleteSectionTitles || false;
CF.perPage = CF.paginationPerPage || 10;
CF.pageSizeOptions = CF.paginationPageSizeOptions || [5, 10, 20, 50, 100];
CF.initialCurrentPage = CF.paginationCurrentPage || 1;
CF.showNewSearchAdvancedFilterDesign = true;
CF.showNewSearchItemDesign = true;

/*
* In variant 2 we have next changes:
* All links to Profile page will trigger expand view (Clicking the whole listing area will also toggle the expanded view. The can only get to the profile page by clicking the text link in the expanded view.)
* Modify column width in the listing result to 64% and 36% (currently at 66.7% and 33.3%) (Font size will remain the same. We just want the booking column slightly wider. Just a CSS tweak on the columns).
* */
CF.showSearchItemVariant_2 = CF.showSearchItemVariant_2 || false;

const blogArticlesCache = {};
let insuranceListPromise = null;
const coachInsurancesPromises = {};

const store = new Vuex.Store({
    state: {
        search: {
            count: 0,
            totalCount: 0,
            nearbyCount: 0,
            currentPage: 0,
            hasNextPage: false,
            nextPageURL: null,
            pending: false,
            searchResults: [],
            nearbyCoaches: [],
            mapMarkers: [],
            mapMarkersTotal: 0,
            mapMarkersPending: false,
            mapMarkersKey: null,
            hasBookingAvailableCoaches: false,
            appointmentsDateStartFrom: moment(0, 'HH'),
            appointmentsDateRange: null,
            selectedResultItem: null,
            methods: [],
            symptoms: [],
            aiRateLimit: null,  // Will store AI rate limit info if limit is exceeded
            searchQueryId: null,
            CF,
            oldFilter: {},
            for_day_status: '',
            // SS-1294: AJAX pagination state (Vue-rendered bar).
            perPage: CF.perPage,
            pageSizeOptions: CF.pageSizeOptions,
            resultCount: 0,
            pageCount: 0,
            // SS-1294: hover-prefetch cache. Maps a deterministic
            // (filter + page) key to the in-flight /coach/ promise. Cleared
            // on any filter/sort/per-page change so stale pages are never
            // served. See PREFETCH_PAGE / LOAD_PAGINATED_PAGE.
            prefetchCache: {},
            filter: {
                q: '',
                treatments: '',
                location: '',
                location_name: '',
                distance: '0',
                ordering: 'best-match'
            }
        },
        coachPhotos: [],
        separateProfilePracticePhotos: false,
        bestReview: {},
        lang: DEFAULT_LANGUAGE,
        autocomplete: {
            methodList: {},
            locationList: {},
            suggestedMethodList: {},
            suggestedLocationList: {},
            selectedMethodItem: {},
            selectedLocationItem: {}
        },
        isMobileNavActive: false,
        isInsurancePage: false,
        tbookingProfile: {},
        healthAdvisorProfile: {},
    },
    actions: {
        LOAD_SPECIFIC_PAGE: function ({commit, state, dispatch }, page) {
            if (_.isEqual(state.search.filter, state.search.oldFilter)) return;

            commit('SET_SEARCH_RESULT_PENDING', true);
            dispatch('LOAD_MAP_MARKERS');

            var req = fetchCoachList(state, {
                params: {
                    page,
                    ...state.search.filter,
                    location_name: undefined,
                    is_zsr_number_required: state.isInsurancePage ? true : undefined
                },
                paramsSerializer(params){
                    return qs.stringify(params, {arrayFormat: 'repeat'});
                }
            });
            if (!req) {
                commit('SET_SEARCH_RESULT_PENDING', false);
                return Promise.resolve();
            }
            return req.then((response) => {
                response.data.currentPage = page
                commit('SET_SEARCH_RESULT', response.data);
            }, (error) => {
                commit('SET_SEARCH_RESULT_PENDING', false);
                console.log('error');
                console.log(error);
            });
        },
        // SS-1294: AJAX pagination. Unlike LOAD_SPECIFIC_PAGE, this always
        // loads (no isEqual guard) because paginating does not change the
        // filter, only the page number.
        //
        // Hover prefetch: when the user hovers a page link we fire the same
        // /coach/ request in the background and cache its promise. On the
        // actual click we reuse that promise if present, so the click feels
        // instant. The cache key includes the full filter state, so a
        // prefetched page from a stale filter set is never served after the
        // user changes filters/sorting (the cache is cleared in SET_FILTER /
        // SET_PER_PAGE).
        LOAD_PAGINATED_PAGE: function ({commit, state, dispatch}, page) {
            // SS-1294: show the card-list spinner immediately on click so the
            // user sees feedback while the (possibly already in-flight from
            // hover) request finishes. Scroll is handled by PaginationBar
            // before this action runs.
            commit('SET_SEARCH_RESULT_PENDING', true);
            dispatch('LOAD_MAP_MARKERS');

            const key = _paginatedPageKey(state.search.filter, page, state.isInsurancePage);
            const cache = state.search.prefetchCache;
            let promise = cache[key];
            const fromCache = !!promise;
            if (!promise) {
                // Cold click (no prior hover): start the request and stash it
                // in the cache so a second click cannot fire a duplicate.
                promise = fetchCoachList(state, {
                    params: _paginatedPageParams(state.search.filter, page, state.isInsurancePage),
                    paramsSerializer(params){
                        return qs.stringify(params, {arrayFormat: 'repeat'});
                    }
                });
                if (!promise) {
                    commit('SET_SEARCH_RESULT_PENDING', false);
                    return Promise.resolve();
                }
                const keys = Object.keys(cache);
                if (keys.length >= PREFETCH_CACHE_MAX_PAGES) {
                    delete cache[keys[0]];
                }
                cache[key] = promise;
            }

            return promise.then((response) => {
                response.data.currentPage = page;
                commit('SET_SEARCH_RESULT', response.data);
                if (fromCache) {
                    // No list request was made for this view: tell the
                    // search log the (prefetched) page was actually shown.
                    confirmPageViewed(state, page);
                }
            }, (error) => {
                commit('SET_SEARCH_RESULT_PENDING', false);
                console.log('error');
                console.log(error);
            });
        },
        // SS-1294: silent prefetch on hover/focus. Fetches the page with the
        // CURRENT filter state and stores the promise in the cache; does not
        // touch the UI (no pending flag, no commit). If the same key is
        // already in flight, reuse the existing promise (no double request).
        // A later click on LOAD_PAGINATED_PAGE reuses this same promise.
        PREFETCH_PAGE: function ({state}, page) {
            const key = _paginatedPageKey(state.search.filter, page, state.isInsurancePage);
            if (state.search.prefetchCache[key]) return state.search.prefetchCache[key];
            const promise = fetchCoachList(state, {
                params: _prefetchPageParams(state.search.filter, page, state.isInsurancePage),
                paramsSerializer(params){
                    return qs.stringify(params, {arrayFormat: 'repeat'});
                }
            });
            if (!promise) {
                return Promise.resolve();
            }
            // Cap the cache to avoid unbounded growth: drop oldest entries
            // beyond a small limit. Filter changes already wipe it, so this
            // only guards against many hovers within one filter set.
            const cache = state.search.prefetchCache;
            const keys = Object.keys(cache);
            if (keys.length >= PREFETCH_CACHE_MAX_PAGES) {
                delete cache[keys[0]];
            }
            cache[key] = promise;
            return promise;
        },
        LOAD_SEARCH_RESULT: function ({commit, state, dispatch}) {
            if (_.isEqual(state.search.filter, state.search.oldFilter)) return;

            commit('SET_SEARCH_RESULT_PENDING', true);
            dispatch('LOAD_MAP_MARKERS');

            var req = fetchCoachList(state, {
                params: {
                    ...state.search.filter,
                    location_name: undefined,
                    is_zsr_number_required: state.isInsurancePage ? true : undefined
                },
                paramsSerializer(params){
                    return qs.stringify(params, {arrayFormat: 'repeat'});
                }
            });
            if (!req) {
                // Leave Vue list empty so Django SSR cards stay visible.
                commit('SET_SEARCH_RESULT_PENDING', false);
                return Promise.resolve();
            }
            return req.then((response) => {
                commit('SET_SEARCH_RESULT', response.data);
            }, (error) => {
                commit('SET_SEARCH_RESULT_PENDING', false);
                console.log('error');
                console.log(error);

                // Check if this is a 429 rate limit error with data
                if (error.response && error.response.status === 429 && error.response.data) {
                    // Still set the search results (coaches are returned even when rate limited)
                    commit('SET_SEARCH_RESULT', error.response.data);
                }
            });
        },
        // Markers for the search map, same filters as the list, requested in
        // parallel with the list (it does not wait for it). The server returns
        // everything when the search fits mapsMaxMapCoaches, otherwise the
        // best-ranked mapsMaxMapCoaches and "Load all" (options.all) fetches
        // the rest. Paging the list does not reload markers for an unchanged
        // filter.
        LOAD_MAP_MARKERS: function ({commit, state}, options) {
            if (!(window.cf && window.cf.mapsShowExtraCoaches === true) || isLandingSsrBotPreview(state)) {
                commit('RESET_MAP_MARKERS');
                return;
            }

            options = options || {};
            const filterKey = _mapMarkersKey(state.search.filter, state.isInsurancePage);
            const alreadyLoaded = state.search.mapMarkersKey === filterKey
                && (state.search.mapMarkers.length || state.search.mapMarkersPending);
            if (alreadyLoaded && !options.all) return;

            const params = {
                ...state.search.filter,
                location_name: undefined,
                is_zsr_number_required: state.isInsurancePage ? true : undefined,
            };
            if (options.all) {
                params.all = 1;
            } else {
                params.max = Number(window.cf.mapsMaxMapCoaches) || 100;
            }

            const requestId = ++_mapMarkersRequestSeq;
            commit('SET_MAP_MARKERS_KEY', filterKey);
            commit('SET_MAP_MARKERS_PENDING', true);

            return Vue.http.get('/coach/map_markers/', {
                params,
                paramsSerializer(params){
                    return qs.stringify(params, {arrayFormat: 'repeat'});
                }
            }).then((response) => {
                if (requestId !== _mapMarkersRequestSeq) return;  // a newer request replaced this one
                const data = (response && response.data) || {};
                const markers = data.results || [];
                if (data.view_url_template) {
                    // Compact markers carry only the slug; the profile URL template
                    // (request language) comes once per response.
                    markers.forEach((marker) => {
                        marker.view_url = data.view_url_template.replace('SLUG', marker.slug);
                    });
                }
                commit('SET_MAP_MARKERS', markers);
                commit('SET_MAP_MARKERS_TOTAL', Number(data.total) || 0);
                commit('SET_MAP_MARKERS_PENDING', false);
            }, (error) => {
                if (requestId !== _mapMarkersRequestSeq) return;
                console.log('LOAD_MAP_MARKERS error');
                console.log(error);
                commit('RESET_MAP_MARKERS');
            });
        },
        LOAD_NEXT_PAGE: function ({commit, state}) {
            if (state.search.hasNextPage) {
                let nextPageURL = state.search.nextPageURL;
                let baseURLLen = baseURL.length;
                let baseURLEnd = nextPageURL.indexOf(baseURL) + baseURLLen - 1;
                let url = nextPageURL.substr(baseURLEnd);

                commit('SET_SEARCH_RESULT_PENDING', true);

                var req = fetchCoachListUrl(state, url);
                if (!req) {
                    commit('SET_SEARCH_RESULT_PENDING', false);
                    return Promise.resolve();
                }
                return req.then((response) => {
                    commit('ADD_SEARCH_RESULT', response.data);
                }, (error) => {
                    commit('SET_SEARCH_RESULT_PENDING', false);

                    console.log('error');
                    console.log(error);
                })
            }
        },
        LOAD_ITEM_DETAILS: function ({commit, state}, detailUrl) {
            return Vue.http.get(detailUrl).then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                return null;
            });
        },
        LOAD_INSURANCE_LIST: function ({commit, state, dispatch}, loaded = {}) {
            // If this is the initial call (not a recursive pagination call), return cached promise
            if (!loaded.next && !loaded.results && insuranceListPromise) {
                return insuranceListPromise;
            }

            const promise = Vue.http.get(loaded.next || '/insurance/').then((response) => {
                const next = getValue(response, 'data.next');
                const results = [ ...(loaded.results || []), ...(getValue(response, 'data.results') || []) ];

                if (next && results.length) {
                    return dispatch('LOAD_INSURANCE_LIST', { next, results })
                }

                return results;
            }, (error) => {
                console.log('error');
                console.log(error);
                insuranceListPromise = null;
                return [];
            });

            // Cache only the initial call promise
            if (!loaded.next && !loaded.results) {
                insuranceListPromise = promise;
            }

            return promise;
        },
        LOAD_COACH_INSURANCES: function ({commit, state}, slug) {
            if (coachInsurancesPromises[slug]) {
                return coachInsurancesPromises[slug];
            }

            coachInsurancesPromises[slug] = Vue.http.get('/coach/' + slug +'/insurances/').then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                delete coachInsurancesPromises[slug];
                return [];
            });

            return coachInsurancesPromises[slug];
        },
        UPDATE_COACH_INSURANCES: function ({commit, state}, coach) {
            return Vue.http.post('/coach/' + coach.slug +'/insurances/',
                { payload: coach.insurances },
                { headers: {"x-csrftoken": coach.csrftoken} })
                .then((response) => {
                    return response.data;
                }, (error) => {
                    console.log('error');
                    console.log(error);
                    return null;
                });
        },
        LOAD_COACH_METHODS: function ({commit, state}) {
            return Vue.http.get('/method/selected/').then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                return [];
            });
        },
        GET_COACH_BOOKING_INFO: function ({commit, state}) {
            return Vue.http({
                url: BOOKING_API + '/user/ping',
                adapter: jsonpAdapter
            }).then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                return null;
            });
        },
        GET_NEW_COACH_BOOKINGS: function ({commit, state}, officeId) {
            return Vue.http({
                url: NEW_BOOKING_API + '/booking/' + officeId,
                adapter: jsonpAdapter
            }).then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                return null;
            });
        },
        LOAD_AUTOCOMPLETE_METHODS: function ({commit, state}, params) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/' + state.lang + '/autocomplete/', {params}).then((response) => {
                commit('SET_AUTOCOMPLETE_METHOD_LIST', response.data);
            }, (error) => {
                commit('SET_AUTOCOMPLETE_METHOD_LIST', {});
                console.log('error');
                console.log(error);
            })
        },
        LOAD_AUTOCOMPLETE_LOCATIONS: function ({commit, state}, params) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/' + state.lang + '/autocomplete/', {params}).then((response) => {
                commit('SET_AUTOCOMPLETE_LOCATION_LIST', response.data);
            }, (error) => {
                commit('SET_AUTOCOMPLETE_LOCATION_LIST', {});
                console.log('error in LOAD_AUTOCOMPLETE_LOCATIONS');
                console.log(error);
            })
        },
        LOAD_AUTOCOMPLETE_SUGGESTED_METHODS: function ({commit, state}) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/' + state.lang + '/autocomplete/').then((response) => {
                commit('SET_SUGGESTED_TAGS_LIST', response.data);
            }, (error) => {
                console.log('error');
                console.log(error);
            })
        },
        LOAD_COACH_SERVICES: function ({commit}, slug) {
            return Vue.http.get(NEW_BOOKING_API + '/office/' + slug + '/bookingProfile').then((response) => {
              return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
            })
        },
        LOAD_COACH_FREE_SLOTS: function ({commit}, params) {
            return Vue.http.get(NEW_BOOKING_API + '/timeSlots', {params}).then((response) => {
              return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
            })
        },
        CONFIRM_BOOKING: function ({commit}, data) {
            return Vue.http.post(OLD_BOOKING_CONFIRM_URL, data, bookingPostConfig()).then((response) => {
              return response.data;
            }, (error) => {
                if (error && error.response && error.response.data) {
                    return error.response.data;
                }
                console.log('error');
                console.log(error);
            });
        },
        SEND_BOOKING_OTP: function ({commit}, data) {
            return Vue.http.post('/api/v1/booking/otp/send/', {lang: DEFAULT_LANGUAGE, ...data}, bookingPostConfig()).then((response) => {
                return response.data;
            }, (error) => {
                if (error && error.response && error.response.data) {
                    return error.response.data;
                }
                return {success: false, message: 'Network error'};
            });
        },
        VERIFY_BOOKING_OTP: function ({commit}, data) {
            return Vue.http.post('/api/v1/booking/otp/verify/', data, bookingPostConfig()).then((response) => {
                return response.data;
            }, (error) => {
                if (error && error.response && error.response.data) {
                    return error.response.data;
                }
                return {success: false, message: 'Network error'};
            });
        },
        SUCCESS_PAYMENT: function({commit}, url) {
            return Vue.http.get(url, {baseURL: ''}).then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
            })
        },
        SEND_BOOKING_OFF_REASON: function({commit}, reasonCode) {
            return Vue.http.post('/off-bookings/', {
                reason: reasonCode
            }).then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
            });
        },
        LOGIN: function ({commit, state}, data) {
            const csrfToken = data.csrfmiddlewaretoken || getCsrfToken();
            const headers = {
                'X-Requested-With': 'XMLHttpRequest'
            };
            if (csrfToken) {
                headers['X-CSRFToken'] = csrfToken;
            }
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + '/' + state.lang + '/konto/login/',
                qs.stringify(data, {arrayFormat: 'repeat'}), {
                headers
            }).then((response) => {
              return response.data;
            });
        },
        LOAD_COACH_PHOTOS: function ({commit}) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/api/photo/').then((response) => {
                commit('SET_COACH_PHOTOS', {
                    photos: response.data.photos,
                    separateProfilePracticePhotos: response.data.separate_profile_practice_photos,
                });
            }, (error) => {
                console.log('LOAD_COACH_PHOTOS error');
                console.log(error);
            })
        },
        SET_MAIN_COACH_PHOTO: function ({commit}, photoId) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/api/photo/' + photoId + '/set-main/').then((response) => {
                commit('SET_MAIN_COACH_PHOTO', photoId);
            }, (error) => {
                console.log('SET_MAIN_COACH_PHOTO error');
                console.log(error);
            });
        },
        REMOVE_COACH_PHOTO: function ({commit}, photoId) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/api/photo/' + photoId + '/delete/').then((response) => {
                commit('DELETE_COACH_PHOTO', photoId);
            }, (error) => {
                console.log('REMOVE_COACH_PHOTO error');
                console.log(error);
            });
        },
        LOAD_SUGGESTIONS: function ({commit}, params) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + '/api/web/' + params.model + '/?search=' + params.query)
            .then((response) => {
                return response.data;
            }, (error) => {
                console.log('LOAD_SUGGESTIONS error');
                console.log(error);
            });
        },
        GET_COACH_REVIEW_TAGS: function ({commit, state}, path) {
            return Vue.http.get(AUTOCOMPLETE_METHOD_URL + path).then((response) => response.data);
        },
        SEND_REVIEW_DATA: function ({commit, state}, options) {
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        SEND_COMMUNITY_QUESTION_DATA: function ({commit, state}, options) {
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        SEND_COMMUNITY_QUESTION_UPDATE_DATA: function ({commit, state}, options) {
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        SEND_COMMUNITY_QUESTION_VOTE_DATA: function ({commit, state}, options) {
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        LOAD_UNANSWERED_COMMUNITY_QUESTIONS_STATUS: function ({commit, state}, coachId) {
            return Vue.http.get(
                AUTOCOMPLETE_METHOD_URL + '/' + state.lang + '/community/question/unanswered/' + coachId + '/').then((response) => {
                return response.data;
            }, (error) => {
                console.log('error');
                console.log(error);
                return [];
            });
        },
        UPDATE_USER_SETTINGS: function ({commit, state}, options) {
            return Vue.http.post(
                options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        SEND_TRACK_PHONE_CLICK: function ({commit, state}, options) {
            return Vue.http.post(
                AUTOCOMPLETE_METHOD_URL + options.url,
                qs.stringify(options.body, {arrayFormat: 'repeat'}), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => response.data);
        },
        LOAD_BLOG_ARTICLES: function ({commit, state}, path) {
            if (blogArticlesCache[path]) return Promise.resolve(blogArticlesCache[path]);

            return Vue.http.get(path).then(response => {
                var $el = document.createElement( 'html' );
                $el.innerHTML = response.data;
                var $main = $el.querySelector('#main');

                blogArticlesCache[path] = $main.outerHTML;

                return blogArticlesCache[path];
            });
        },
        LOAD_BANNER: function({commit, state}) {
            return Vue.http.get('banner/')
            .then((response) => {
                console.log(response);
                return response.data;
            }, (error) => {
                return null;
            });
        },
        LOAD_TBOOKING_PROFILE: function({commit, state}, coachId) {
            return Vue.http.get(`tbooking/${coachId}/profile/`)
            .then((response) => {
                commit('SET_TBOOKING_PROFILE', response.data);
            }, (error) => {
                return null;
            });
        },
        LOAD_TBOOKING_SLOTS: function({commit, state}, options) {
            return Vue.http.get(`tbooking/${options.userId}/${options.treatmentId}/slots/`)
                .then((response) => {
                    return response.data;
                }, (error) => {
                    return null;
                });
        },
        CREATE_TBOOKING: function({commit, state}, options) {
            return Vue.http.post(`tbooking/${options.coachId}/bookings/`,
                options.payload,
                { headers: {"x-csrftoken": options.csrftoken} })
                    .then((response) => {
                        return response.data;
                    }, (error) => {
                        return null;
                    });
        },
        LOAD_HEALTH_ADVISOR_PROFILE: function({commit, state}, coachId) {
            return Vue.http.get(`health-advisor/${coachId}/profile/`)
            .then((response) => {
                commit('SET_HEALTH_ADVISOR_PROFILE', response.data);
            }, (error) => {
                return null;
            });
        },
        LOAD_HEALTH_ADVISOR_SLOTS: function({commit, state}, options) {
            return Vue.http.get(`health-advisor/${options.userId}/${options.treatmentId}/slots/`)
                .then((response) => {
                    return response.data;
                }, (error) => {
                    return null;
                });
        },
        CREATE_HEALTH_ADVISOR_BOOKING: function({commit, state}, options) {
            return Vue.http.post(`health-advisor/${options.coachId}/bookings/`,
                options.payload,
                { headers: {"x-csrftoken": options.csrftoken} })
                    .then((response) => {
                        return response.data;
                    }, (error) => {
                        return null;
                    });
        },
    },
    mutations: {
        SET_FILTER: (state, query) => {
            const filter = {};
            const treatments = [];

            filter.location = query.location || '';
            filter.location_name = query.locationName || '';

            if (query.methods) {
              treatments.push(query.methods);
            }

            if (query.symptoms) {
              treatments.push(query.symptoms);
            }

            if(!treatments.length){
              filter.q = query.query || '';
            }

            // Add user_query parameter for free-text search
            if (query.user_query) {
              filter.user_query = query.user_query;
            }

            if (query.insurance != null) {
                filter.insurance = query.insurance;
            }

            if(query.insuranceState != null){
              filter.insurance_status = query.insuranceState;
            }

            if(query.isRated){
              filter.is_rated = 'yes';
            }

            if(CF.landingPageID !== undefined){
              filter.lp = CF.landingPageID;
            }

            if (CF.page === 'landingpage' && CF.landingPageID !== undefined) {
              filter.page_origin = 'landingpage';
            } else if (CF.page === 'search') {
              filter.page_origin = 'search';
            }

            if(query.gender){
              filter.gender = query.gender;
            }

            if(query.distance !== undefined){
              filter.distance = query.distance;
            } else if (!('distance' in query)) {
                filter.distance = state.search.filter.distance;
            }

            if(query.languages){
              filter.languages = query.languages;
            }

            if(query.target_groups){
              filter.target_groups = query.target_groups;
            }

            if(query.ordering){
              filter.ordering = query.ordering;
            } else if (!('ordering' in query)) {
                filter.ordering = state.search.filter.ordering;
            }

            // SS-1294: forward "coaches per page" to the search API.
            if (query.per_page) {
                filter.per_page = query.per_page;
            }

            if (!('for_day_status' in query) && state.search.for_day_status) {
                query.for_day_status = state.search.for_day_status;
            }

            if(query.for_day_status){
              state.search.for_day_status = query.for_day_status;

              filter.start = moment().startOf('day').diff(0, 'seconds');

              let days = query.for_day_status === 'today' ? 1 : 3;

              filter.end = moment().add(days, 'days').startOf('day').diff(0, 'seconds');

              state.search.appointmentsDateStartFrom = moment(0, 'HH');

              state.search.appointmentsDateRange = null;
            } else {
                state.search.for_day_status = '';
            }

            if ('for_day_time_range' in query) {
                state.search.appointmentsDateRange = query.for_day_time_range || null;
            }

            if(state.search.appointmentsDateRange){
                const [from, to] = state.search.appointmentsDateRange;

                filter.start = moment(from).diff(0, 'seconds');
                filter.end = moment(to).diff(0, 'seconds');
            }

            filter.treatments = treatments.join(',');

            state.search.oldFilter = state.search.filter;
            state.search.filter = _.pickBy(filter, function (item) {
                return !_.isNil(item) && item !== '';
            });
            // SS-1294: filter/sort changed → any prefetched pages are stale.
            state.search.prefetchCache = {};
        },
        CLEAR_APPOINTMENTS_DATE_RANGE: (state) => {
            state.search.appointmentsDateRange = null;

            delete state.search.filter.start;
            delete state.search.filter.end;
        },
        SET_SEARCH_RESULT_PENDING: (state, isPending) => {
            state.search.pending = isPending;
        },
        // SS-1294: update "coaches per page" for the AJAX pagination bar.
        SET_PER_PAGE: (state, perPage) => {
            state.search.perPage = perPage;
            if (perPage) {
                state.search.filter.per_page = perPage;
            } else {
                delete state.search.filter.per_page;
            }
            // SS-1294: per-page changes the result set, so any prefetched
            // pages are now stale.
            state.search.prefetchCache = {};
        },
        SET_SEARCH_RESULT: (state, response) => {
            state.search.totalCount = response.total_count;
            state.search.nearbyCount = response.nearby_count || 0;
            state.search.count = state.search.totalCount - state.search.nearbyCount;
            state.search.resultCount = response.count;
            state.search.pageCount = response.page_count || 0;
            state.search.hasNextPage = response.next ? true : false;
            state.search.nextPageURL = response.next;
            state.search.searchResults = response.results;
            state.search.nearbyCoaches = response.nearby_coaches || [];
            state.search.hasBookingAvailableCoaches = response.has_booking_available_coaches;
            state.search.methods = response.filters.methods;
            state.search.symptoms = response.filters.symptoms;
            state.search.currentPage = !isNaN(Number(response.currentPage)) ?
            Number(response.currentPage) : 1;
            state.search.pending = false;

            // Store AI rate limit info if present
            state.search.aiRateLimit = response.ai_rate_limit || null;
            state.search.searchQueryId = response.search_query_id || null;

            if(response.premium_coaches && response.premium_coaches.length){
                state.search.searchResults = [...response.premium_coaches, ...state.search.searchResults];
            }
        },
        ADD_SEARCH_RESULT: (state, response) => {
            state.search.totalCount = response.total_count;
            state.search.nearbyCount = response.nearby_count || 0;
            state.search.count = state.search.totalCount - state.search.nearbyCount;
            state.search.hasNextPage = response.next ? true : false;
            state.search.nextPageURL = response.next;
            state.search.searchResults = state.search.searchResults.concat(response.results);
            state.search.nearbyCoaches = state.search.nearbyCoaches.concat(response.nearby_coaches || []);
            state.search.hasBookingAvailableCoaches = state.search.hasBookingAvailableCoaches || response.has_booking_available_coaches;
            state.search.methods = response.filters.methods;
            state.search.symptoms = response.filters.symptoms;
            state.search.currentPage++;
            state.search.pending = false;
            state.search.searchQueryId = response.search_query_id || state.search.searchQueryId;
        },
        SET_MAP_MARKERS: (state, markers) => {
            // Frozen: Vue must not make thousands of marker objects reactive
            // (slow and memory-hungry); the map only reads them.
            state.search.mapMarkers = Object.freeze(markers || []);
        },
        SET_MAP_MARKERS_TOTAL: (state, total) => {
            state.search.mapMarkersTotal = Number(total) || 0;
        },
        SET_MAP_MARKERS_PENDING: (state, pending) => {
            state.search.mapMarkersPending = !!pending;
        },
        SET_MAP_MARKERS_KEY: (state, key) => {
            state.search.mapMarkersKey = key;
        },
        RESET_MAP_MARKERS: (state) => {
            state.search.mapMarkers = [];
            state.search.mapMarkersTotal = 0;
            state.search.mapMarkersPending = false;
            state.search.mapMarkersKey = null;
        },
        SET_AUTOCOMPLETE_METHOD_LIST: (state, response) => {
            state.autocomplete.methodList = response;
        },
        SET_AUTOCOMPLETE_LOCATION_LIST: (state, response) => {
            state.autocomplete.locationList = response;
        },
        SET_SUGGESTED_TAGS_LIST: (state, response) => {
            let result = [];
            const keys = Object.keys(response);

            keys.forEach((group) => {
                if (group === 'location') return;

                result = response[group].items ? result.concat(response[group].items) : result;
            });

            state.autocomplete.suggestedMethodList = result;
            state.autocomplete.suggestedLocationList = getValue(response, 'location.items') || [];
        },
        SET_AUTOCOMPLETE_METHOD_ITEM: (state, response) => {
            state.autocomplete.selectedMethodItem = response;
        },
        SET_SELECTED_ITEM: (state, response) => {
            state.search.selectedResultItem = response;
        },
        SET_BEST_REVIEW: (state, response) => {
            state.bestReview = response || {};
        },
        SET_APPOINTMENTS_DATE_START_FROM: (state, response) => {
            state.search.appointmentsDateStartFrom = moment(state.search.appointmentsDateStartFrom).add(response, 'day');
        },
        SET_MOBILE_NAVIGATION_ACTIVE: (state) => {
            state.isMobileNavActive = true;
        },
        SET_MOBILE_NAVIGATION_DISABLED: (state) => {
            state.isMobileNavActive = false;
        },
        SET_IS_INSURANCE_PAGE: (state, val) => {
            state.isInsurancePage = val;
        },
        SET_COACH_PHOTOS: (state, payload) => {
            if (Array.isArray(payload)) {
                state.coachPhotos = payload;
                return;
            }

            state.coachPhotos = payload.photos;
            if (payload.separateProfilePracticePhotos !== undefined) {
                state.separateProfilePracticePhotos = payload.separateProfilePracticePhotos;
            }
        },
        SET_MAIN_COACH_PHOTO: (state, photoId) => {
            let oldProfilePhoto = state.coachPhotos.filter(photo => photo.is_profile_photo)[0];
            if (oldProfilePhoto) {
                oldProfilePhoto.is_profile_photo = false;
            }

            state.coachPhotos = state.coachPhotos.map(photo => {
                if (photo.id === photoId) {
                    photo.is_profile_photo = true;
                }

                return photo;
            });
        },
        DELETE_COACH_PHOTO: (state, photoId) => {
            state.coachPhotos = state.coachPhotos.filter(photo => photo.id !== photoId);

            if (!state.separateProfilePracticePhotos) {
                const profilePhotos = state.coachPhotos.filter(photo => photo.is_profile_photo);

                if (!profilePhotos.length && _.get(state, 'coachPhotos[0].is_profile_photo') === false) {
                    state.coachPhotos[0].is_profile_photo = true;
                }
            }
        },
        SAVE_SEARCH_PAGE_STATE: (state) => {
            const pageHref = location.href;
            const searchData = state.search;
            const scrollTop = document.body.scrollTop || document.querySelector('html').scrollTop;
            const expiration = Date.now() + 1000 * 60 * 10;  // will expire after 10 minutes

            const data = {
                [pageHref]: searchData,
                scrollTop,
                expiration
            };

            localStorage.setItem('stored_search_page_state', JSON.stringify(data));
        },
        RESTORE_SEARCH_PAGE_STATE: (state) => {
            const storedSearchPageState = localStorage.getItem('stored_search_page_state');

            if (!storedSearchPageState) return;

            let searchData;

            try {
                searchData = JSON.parse(storedSearchPageState);
            } catch (error) {
                console.error(error);
            }

            const pageHref = location.href;

            if (searchData && pageHref in searchData && Date.now() < searchData.expiration) {
                state.search = searchData[pageHref];
                // localStorage snapshots predate derived CF fields; recompute
                // so pagination vs infinite-scroll matches the restored page.
                resolveSearchUsePagination(state.search && state.search.CF);
                if (state.search && state.search.CF) {
                    state.search.CF.ssrBotPreview = resolveSsrBotPreview();
                }

                setTimeout(() => window.scrollTo(0, searchData.scrollTop), 0);
            }

            localStorage.removeItem('stored_search_page_state');
        },
        SET_SCARCITY_LABEL: (state, response) => {
            state.search.CF.showScarcityLabel = response;
        },
        SHOW_NEW_SEARCH_ADVANCED_FILTER_DESIGN: (state, response) => {
            state.search.CF.showNewSearchAdvancedFilterDesign = response;
        },
        SHOW_NEW_SEARCH_ITEM_DESIGN: (state, response) => {
            state.search.CF.showNewSearchItemDesign = response;
        },
        SHOW_SEARCH_ITEM_VARIANT_2: (state, response) => {
            state.search.CF.showSearchItemVariant_2 = response;
        },
        SET_TBOOKING_PROFILE: (state, response) => {
            state.tbookingProfile = response;
        },
        SET_HEALTH_ADVISOR_PROFILE: (state, response) => {
            state.healthAdvisorProfile = response;
        },
    },
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js